import type {
    ImportedPropertiesSelectionPagePropertyOnboardingContextFieldsV1,
    ImportedPropertiesSelectionPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BackElementPropertyOnboardingManifestV1,
    ChooseListingFooterTextElementPropertyOnboardingManifestV1,
    ChooseListingFromUrlBadgeElementPropertyOnboardingManifestV1,
    ImportButtonElementPropertyOnboardingManifestV1,
    ImportedExternalLinkElementPropertyOnboardingManifestV1,
    ImportedPublishingBadgeElementPropertyOnboardingManifestV1,
    ImportedSectionElementPropertyOnboardingManifestV1,
    ListingCardElementPropertyOnboardingManifestV1,
    SelectLanguageElementPropertyOnboardingManifestV1,
    UniversalSelectionElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    ImportedPropertiesSelectionPagePropertyOnboardingContextManifestV1,
    WebImportedPropertiesSelectionVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/imported-properties-selection-page";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const automaticListsBinder = defineBinder(({ webAnalytics, action: { click, reveal, hover } }) => {
    webAnalytics.pageContext<
        ImportedPropertiesSelectionPagePropertyOnboardingContextIdsV1,
        ImportedPropertiesSelectionPagePropertyOnboardingContextFieldsV1
    >(ImportedPropertiesSelectionPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        property_id: BaseContextFieldsMapping.property_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebImportedPropertiesSelectionVisitEventPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], SelectLanguageElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal, hover], ListingCardElementPropertyOnboardingManifestV1.ids, {
        action_element_index: (element: HTMLElement) => GetAttributeSafe(element, "data-property-id"),
    });
    webAnalytics.observeElement([click, hover], ImportedExternalLinkElementPropertyOnboardingManifestV1.ids, {
        property_id: (element: HTMLElement) => GetAttributeSafe(element, "data-property-id"),
    });
    webAnalytics.observeElement([click], UniversalSelectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ImportButtonElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], ChooseListingFooterTextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], ImportedSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([hover], ChooseListingFromUrlBadgeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([hover], ImportedPublishingBadgeElementPropertyOnboardingManifestV1.ids, {
        property_id: (element: HTMLElement) => GetAttributeSafe(element, "data-property-id"),
    });
});
